import { Directive, HostListener, input } from '@angular/core';

@Directive({
  selector: '[coreOpenInNewTab]',
  standalone: true,
})
export class OpenInNewTabDirective {
  coreOpenInNewTab = input.required<string>();

  @HostListener('click', ['$event'])
  onClick(event: MouseEvent): void {
    event.preventDefault();
    event.stopPropagation();

    const url = this.coreOpenInNewTab();
    const newWindow = window.open('', '_blank');

    if (newWindow) {
      for (let i = 0; i < sessionStorage.length; i++) {
        const key = sessionStorage.key(i);
        if (key) {
          newWindow.sessionStorage.setItem(
            key,
            sessionStorage.getItem(key) as string,
          );
        }
      }
      newWindow.location.href = url;
    }
  }
}
